import React, { useEffect, useState } from "react";
import Select from "react-select";
import AddProduct from "./AddProduct";
import { Table } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getCCJobOrderImportCurrencyList
} from "../../../../../../../Redux/action/CustomClearance/CCAction";
import {getCCJobOrderImportShipmentList} from "../../../../../../../Redux/action/CustomClearance/CCImportAction";
import AddShipment from "./AddShipment";
import Beatloader from "../../../../../../../Common/Loaders/Beatloader";
import EditShipment from "./EditShipment";
import Swal from "sweetalert2";
import { adminMainUrl } from "../../../../../../../Config";
import axios from "axios";

const ShipmentTab = ({ token, user_id, b64id, refresh, trans_mode }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [addShow, setAddShow] = useState(false);
  const handleAddClose = () => setAddShow(false);
  const handleAddShow = () => setAddShow(true);
  // const [trans_mode, setTran_mode] = useState("");
  const [shipment_id, setShipment_id] = useState(0);

  const [editShow, setEditShow] = useState(false);
  const handleEditClose = () => setEditShow(false);
  const handleEditShow = (id) => {
    setEditShow(true);
    setShipment_id(id);
  };

  const handleDelete = (id) => {
    let config = {
      // method: "GET",
      headers: {
        "auth-token": token,
        user_id: user_id,
        "Content-Type": "application/json",
      },
    };
    if (!id) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "ID not provided!",
      });
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            `${adminMainUrl}/api/customClearance/import/shipment/delete`,
            {
              id: id,
              custom_clearance_import_job_id: atob(b64id),
            },
            config
          ) // Replace with your API endpoint
          .then((response) => {
            // Success alert
            if (response.status == 200) {
              refresh();
              Swal.fire({
                icon: "success",
                title: "Deleted!",
                text: response.data.msg,
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Error!",
                text: response.data.msg,
              });
            }
          })
          .catch((error) => {
            // Error alert
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong. Please try again.",
            });
          });
      }
    });
  };

  useEffect(() => {
    if (token && user_id) {
      dispatch(getCCJobOrderImportCurrencyList(token, user_id));
      if (b64id) {
        let id = atob(b64id);
        if (id) {
          dispatch(getCCJobOrderImportShipmentList(token, user_id, id));
        }
      }
    }
  }, [token, user_id, b64id]);

  // const refresh = () => {
  //   if (token && user_id && b64id) {
  //     let id = atob(b64id);
  //     if (id) {
  //       dispatch(getCCJobOrderImportInvoiceList(token, user_id, id));
  //     }
  //   }
  // };

  const {
    loadingCCImportJobCurrencyList,
    CCImportJobCurrencyListData,
    CCImportJobCurrencyListDataError,

    loadingCCImportJobShipmentList,
    CCImportJobShipmentListData,
    CCImportJobShipmentListDataError,
  } = useSelector((state) => state?.CCImportReducer);

  //table data
  let [shipmentData, setShipmentData] = useState([]);
  let [showLoader, setShowLoder] = useState(false);

  useEffect(() => {
    if (loadingCCImportJobShipmentList) {
      setShowLoder(true);
    } else {
      setShowLoder(false);
    }

    if (CCImportJobShipmentListData) {
      setShipmentData(CCImportJobShipmentListData);
    }
  }, [loadingCCImportJobShipmentList, CCImportJobShipmentListData]);

  const [currencyOptions, setCurrencyOptions] = useState([]);
  useEffect(() => {
    if (CCImportJobCurrencyListData) {
      let arr = [];
      CCImportJobCurrencyListData.map((val) =>
        arr.push({
          value: val.id,
          label: `${val.currency} (${val.currency_symbol})`,
        })
      );
      setCurrencyOptions(arr);
    }
  }, [loadingCCImportJobCurrencyList, CCImportJobCurrencyListData]);

  // console.log("dsfdsfdf", shipmentData)

  return (
    <>
      {showLoader ? (
        <Beatloader />
      ) : (
        <>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-end mb-4">
                <div
                  className="btn btn-primary cursor-pointer me-2"
                  onClick={handleAddShow}
                  // onClick={() => { navigate("#") }}
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add
                </div>
              </div>


              {trans_mode == "Air" &&
                    <>
              <div className="table-responsive custom-table">
                {/* <Table className="table datanew dataTable no-footer" pagination={false}
                    dataSource={dataSource} columns={columns} /> */}
                <table className="table table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col">S. No.</th>
                      <th scope="col">Airline</th>
                      <th scope="col">Flight No</th>
                      <th scope="col">Flight / Inward Date</th>
                      <th scope="col">IGM No</th>
                      <th scope="col">IGM Date</th>
                      <th scope="col">MAWB No</th>
                      <th scope="col">MAWB Date </th>
                      <th scope="col">HAWB No</th>
                      <th scope="col">HAWB Date</th>
                      {/* <th scope="col">Line No.</th> */}
                      {/* <th scope="col">Packages</th> */}
                      <th scope="col">Gross Wt</th>
                      <th scope="col">Net Wt</th>
                      <th scope="col">Volume</th>
                      <th scope="col">Chargeable Wt</th>
                      <th scope="col">Marks & Nos</th>
                      <th scope="col">Action</th>
                    </tr>
                   
                  </thead>
                  <tbody>
                    {shipmentData?.length > 0 ? (
                      shipmentData?.map((val, index) => {
                        return (
                          <tr key={index + 1}>
                            <th scope="row">{index + 1}</th>
                            <td>{val?.airline_id}</td>
                            <td>{val?.flight_No}</td>
                            <td>{val?.flight_date}</td>
                            <td>{val?.EGM_No}</td>
                            <td>{val?.EGM_Date}</td>
                            <td>{val?.MAWB_No}</td>
                            <td>{val?.MAWB_Date}</td>
                            <td>{val?.HAWB_No}</td>
                            <td>{val?.HAWB_Date}</td>
                            <td>{val?.gross_weight}</td>
                            <td>{val?.net_weight}</td>
                            <td>{val?.volume_weight}</td>
                            <td>{val?.chargeable_weight}</td>
                            <td>{val?.marks_Note}</td>
                            <td>
                              <div className="dropdown table-action">
                                <Link
                                  to="#"
                                  className="action-icon"
                                  data-bs-toggle="dropdown"
                                >
                                  <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                  <div
                                    className="dropdown-item cursor-pointer"
                                    onClick={() => handleEditShow(val?.id)}
                                  >
                                    <i className="fas fa-edit text-blue me-2"></i>{" "}
                                    Edit
                                  </div>
                                  <div
                                    className="dropdown-item cursor-pointer"
                                    onClick={() => handleDelete(val?.id)}
                                  >
                                    <i className="fa-solid fa-trash text-blue me-2"></i>{" "}
                                    Delete
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <>
                        <tr>
                          <td colSpan={20}>
                            {" "}
                            <i>No data found.</i>
                          </td>
                        </tr>
                      </>
                    )}
                    
                  </tbody>
                </table>
              </div>
                    </>
              }
              {trans_mode == "Sea" &&
                    <>
                    
              <div className="table-responsive custom-table">
                {/* <Table className="table datanew dataTable no-footer" pagination={false}
                    dataSource={dataSource} columns={columns} /> */}
                <table className="table table-striped table-sm">
                  <thead>
                  
                    <tr>
                    <th scope="col">S. No.</th>
                      <th scope="col">Shipping Line</th>
                      <th scope="col">Vessel Name</th>
                      <th scope="col">Vessel Date</th>
                      <th scope="col">Voyage No</th>
                      {/* <th scope="col">Vessel Berthing</th> */}
                      {/* <th scope="col">GLD</th> */}
                      {/* <th scope="col">Last Free Date</th> */}
                      <th scope="col">IGM No</th>
                      <th scope="col">IGM Date</th>
                      {/* <th scope="col">MBL No</th>
                      <th scope="col">MBL Date</th>
                      <th scope="col">HBL No</th>
                      <th scope="col">HBL Date</th> */}
                      {/* <th scope="col">Packages</th> */}
                      <th scope="col">Gross Weight</th>
                      <th scope="col">Net Weight</th>
                      <th scope="col">Volume</th>
                      <th scope="col">Chargeable Weight</th>
                      <th scope="col">Marks & Nos</th>
                      {/* <th scope="col">Gateway IGM</th>
                      <th scope="col">Gateway IGM Date</th>
                      <th scope="col">Gateway Inward Date</th>
                      <th scope="col">Port of Reporting</th>
                      <th scope="col">Manifest Line No</th> */}
                      <th scope="col">Action</th>
                    </tr>
                   
                  </thead>
                  <tbody>
                    {shipmentData?.length > 0 ? (
                      shipmentData?.map((val, index) => {
                        return (
                          <tr key={index + 1}>
                            <th scope="row">{index + 1}</th>
                            <td>{val?.shipping_line_id}</td>
                            <td>{val?.vessel_sailing_name}</td>
                            <td>{val?.vessel_sailing_date}</td>
                            <td>{val?.voyage_no}</td>
                            <td>{val?.EGM_No}</td>
                            <td>{val?.EGM_Date}</td>
                            <td>{val?.gross_weight}</td>
                            <td>{val?.net_weight}</td>
                            <td>{val?.volume_weight}</td>
                            <td>{val?.chargeable_weight}</td>
                            <td>{val?.marks_Note}</td>
                            <td>
                              <div className="dropdown table-action">
                                <Link
                                  to="#"
                                  className="action-icon"
                                  data-bs-toggle="dropdown"
                                >
                                  <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                  <div
                                    className="dropdown-item cursor-pointer"
                                    onClick={() => handleEditShow(val?.id)}
                                  >
                                    <i className="fas fa-edit text-blue me-2"></i>{" "}
                                    Edit
                                  </div>
                                  <div
                                    className="dropdown-item cursor-pointer"
                                    onClick={() => handleDelete(val?.id)}
                                  >
                                    <i className="fa-solid fa-trash text-blue me-2"></i>{" "}
                                    Delete
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <>
                        <tr>
                          <td colSpan={20}>
                            {" "}
                            <i>No data found.</i>
                          </td>
                        </tr>
                      </>
                    )}
                    
                  </tbody>
                </table>
              </div>
                    </>
              }
            </div>
          </div>



          <AddShipment
            addShow={addShow}
            handleAddClose={handleAddClose}
            refresh={refresh}
            token={token}
            user_id={user_id}
            b64id={b64id}
            trans_mode={trans_mode}
            loadingCCImportJobCurrencyList={loadingCCImportJobCurrencyList}
            currencyOptions={currencyOptions}
          />
          <EditShipment
            addShow={editShow}
            handleAddClose={handleEditClose}
            refresh={refresh}
            token={token}
            user_id={user_id}
            b64id={b64id}
            trans_mode={trans_mode}
            shipment_id={shipment_id}
            loadingCCImportJobCurrencyList={loadingCCImportJobCurrencyList}
            currencyOptions={currencyOptions}
          />
        </>
      )}
    </>
  );
};

export default ShipmentTab;
